// Adapt a Sam draft (a Material with no persisted Activity behind it) to
// the shape RealizationsListItem reads, so a proposed activity and a todo
// entry go through the exact same component — the tutor sees one single
// kind of activity row on this screen.
//
// Partagé entre la ligne de liste et l'aperçu en modale : une seule
// fonction, sinon les deux copies divergent au premier champ ajouté et
// l'aperçu n'affiche plus ce que la ligne affiche.
export const draftToTodoShape = (activity) => {
    const material = activity?.material ?? null
    return {
        ...activity,
        school_subject_id:
            activity?.school_subject_id ?? material?.school_subject_id ?? null,
        student_chapter: material?.chapter_model
            ? { chapter: material.chapter_model }
            : activity?.student_chapter,
        // TodoActivityBadges reads `estimated_duration` (minutes) and
        // `duration` (seconds spent, null before the student starts).
        estimated_duration:
            activity?.estimated_duration_minutes ??
            material?.estimated_duration ??
            null,
        duration: null,
    }
}
